import { IStorageService } from "@shared/utils/IStorageService";
import { pickBy } from "lodash";
import {
  ACCESS_TOKEN_STORAGE_KEY,
  REFRESH_TOKEN_STORAGE_KEY,
} from "@shared/common/constants";

export const localStorageService: IStorageService<"web"> = {
  clearToken() {
    localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
    localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
  },
  getAccessToken() {
    return localStorage.getItem("access_token") || "";
  },
  getIsDarkMode() {
    const darkMode = localStorage.getItem("dark_mode");
    if (darkMode) return JSON.parse(darkMode);

    return false;
  },
  getParsedValue<T>(key: string) {
    const val = this.getValue(key);
    if (val) {
      try {
        return JSON.parse(val) as T;
      } catch {}
    }

    return null;
  },
  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY) || "";
  },
  getUuid() {
    return localStorage.getItem("uuid");
  },
  getValue(key: string) {
    return localStorage.getItem(key);
  },
  removeUuid() {
    localStorage.removeItem("uuid");
  },
  removeValue(key: string) {
    localStorage.removeItem(key);
  },
  setIsDarkMode(isDarkMode: boolean) {
    localStorage.setItem("dark_mode", isDarkMode.toString());
  },
  setToken(token: string, refreshToken?: string) {
    if (token) {
      localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
    }
    if (refreshToken) {
      localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refreshToken);
    }
  },
  setUuid(uuid: string) {
    localStorage.setItem("uuid", uuid);
  },
  setValue(key: string, val: any) {
    localStorage.setItem(key, val);
  },
  setJsonValue(key: string, val: object) {
    localStorage.setItem(key, JSON.stringify(val));
  },
  getJsonValue(key: string) {
    const value = localStorage.getItem(key);
    try {
      if (value) {
        return JSON.parse(value);
      }
    } catch {}
  },
  setJsonKeyValue(key: string, jsonKey: string, value: any) {
    const previousValue = this.getJsonValue(key) || {};
    this.setJsonValue(key, { ...previousValue, [jsonKey]: value });
  },
  removeJsonValues(key: string, jsonKey: string | string[]) {
    const keysToRemove = typeof jsonKey === "string" ? [jsonKey] : jsonKey;
    const jsonValue = this.getJsonValue(key);
    const updatedJsonValue = pickBy(
      jsonValue,
      (_, jsonKey) => !keysToRemove.includes(jsonKey)
    );
    this.setJsonValue(key, updatedJsonValue);
  },
};

export default localStorageService;
